export const accImageTypes = ['jpg', 'jpeg', 'png'];

export const accDocTypes = ['pdf'];
